import { DTOLiveblocksAuthResponse } from "../dto";
import { DTOLiveblocksAuthRequest } from "../payloads";
import { RequestExecutor } from "../transport/request-executor";

export class LiveblocksEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  auth(body: DTOLiveblocksAuthRequest) {
    return this.requestExecutor.json("/liveblocks/auth", DTOLiveblocksAuthResponse, {
      method: "POST",
      body,
    });
  }
}
